import { useEffect, useState } from "react";

import Chart from 'react-apexcharts'
import moment from "moment";

import LabelForms from '../../../components/labelForms'

import style from '../reports.module.css'

export default function ChartProductByGroup({products}) {
    const [series, setSeries] = useState([]);
    const [options, setOptions] = useState({});

    useEffect(() => {
        const groups = products.reduce((acc, item) => {
            if (!acc[item.ProductGroup.name]) {
              acc[item.ProductGroup.name] = [];
            }
            acc[item.ProductGroup.name].push(item.length);
            return acc;
        }, {})
          
        let product =[]
        let name =[]
        for (let [group, products] of Object.entries(groups)) {
            product.push(products.length)
            name.push(group)
        }
        setOptions({
            labels: name,
                plotOptions: {
                  pie: {
                    donut: {
                      size: '50%',
                    },
                  },
                },
                legend: {
                  position: 'bottom',
                  offsetY: 0,
                
             },
        })
        setSeries(product)
        
    }, [products]);

    return (
        <>
            <div className={style.chart}>
                <LabelForms>Produtos por grupo de produto</LabelForms>
                <Chart options={options} series={series} type="donut" />
            </div>
        </>
    )
}